import React from 'react';

const Logo = ({ className = "", textColor = "text-white" }) => {
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Creative Lantern Icon with Artistic Flair */}
      <svg 
        width="40" 
        height="40" 
        viewBox="0 0 40 40" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        {/* Decorative outer glow */}
        <circle 
          cx="20" 
          cy="20" 
          r="18" 
          className={textColor === "text-white" ? "fill-white" : "fill-purple-200"}
          opacity="0.2"
        />
        
        {/* Artistic lantern shape */}
        <path 
          d="M20 5 L15 10 L25 10 Z" 
          className={textColor === "text-white" ? "fill-white" : "fill-purple-600"}
        />
        
        <path 
          d="M15 10 Q13 18 15 26 L25 26 Q27 18 25 10 Z" 
          className={textColor === "text-white" ? "fill-white" : "fill-purple-500"}
          opacity="0.9"
        />
        
        {/* Inner glow */}
        <circle 
          cx="20" 
          cy="18" 
          r="5" 
          className={textColor === "text-white" ? "fill-white" : "fill-purple-300"}
          opacity="0.8"
        />
        
        <circle 
          cx="20" 
          cy="18" 
          r="3" 
          className={textColor === "text-white" ? "fill-white" : "fill-purple-100"}
        />
        
        {/* Bottom */}
        <path 
          d="M15 26 L20 32 L25 26 Z" 
          className={textColor === "text-white" ? "fill-white" : "fill-purple-600"}
        />
        
        {/* Decorative handle */}
        <path 
          d="M17 5 Q20 2 23 5" 
          className={textColor === "text-white" ? "stroke-white" : "stroke-purple-600"}
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        
        {/* Artistic sparkles */}
        <circle cx="28" cy="15" r="1.5" className={textColor === "text-white" ? "fill-white" : "fill-purple-400"} opacity="0.8"/>
        <circle cx="12" cy="22" r="1.5" className={textColor === "text-white" ? "fill-white" : "fill-purple-400"} opacity="0.8"/>
        <circle cx="26" cy="25" r="1" className={textColor === "text-white" ? "fill-white" : "fill-purple-300"} opacity="0.6"/>
      </svg>
      
      {/* Creative Typography */}
      <div className="flex flex-col leading-tight">
        <span className={`font-bold text-2xl tracking-tight ${textColor}`} style={{letterSpacing: '-0.02em'}}>
          Blue<span className="font-light">Lantern</span>
        </span>
        <span className={`text-xs ${textColor} opacity-75 tracking-widest uppercase`} style={{letterSpacing: '0.15em'}}>
          OutFitters
        </span>
      </div>
    </div>
  );
};

export default Logo;
